"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const Tooltip_1 = require("../Tooltip/Tooltip");
function Checkbox(_a) {
    var { name, label, tooltip } = _a, checkboxInputProps = __rest(_a, ["name", "label", "tooltip"]);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "inline-flex items-center my-2 ml-4" }, { children: [(0, jsx_runtime_1.jsx)("input", Object.assign({ type: "checkbox", name: name, id: name, className: (0, classnames_1.default)('peer', 'w-6', 'min-w-[24px]', 'h-6', 'min-h-[24px]', 'border', 'border-silver-40', 'rounded-full', 
                // Styles for custom checkbox
                'appearance-none', 'checked:bg-blue-80', 
                // Custom checkbox icon
                'checked:bg-checkbox-checked', 'checked:bg-no-repeat', 'checked:bg-center', 'checked:border-[transparent]', 'hover:border-blue-80', 'hover:border-2', 'hover:cursor-pointer') }, checkboxInputProps)), (0, jsx_runtime_1.jsx)("label", Object.assign({ htmlFor: name, className: (0, classnames_1.default)('pl-3', 'text-silver-90', 'text-body-small', 'leading-6', 'peer-hover:text-blue-90', 'peer-checked:text-h200', 'peer-checked:leading-6', 'peer-checked:font-bold', 'peer-checked:text-silver-100', 'peer-checked:hover:text-silver-100', 'hover:cursor-pointer') }, { children: !tooltip ? label : (0, jsx_runtime_1.jsx)(Tooltip_1.Tooltip, Object.assign({ tooltipText: tooltip }, { children: label })) }))] })));
}
exports.Checkbox = Checkbox;
//# sourceMappingURL=Checkbox.js.map